import { Component, OnInit, ComponentFactoryResolver, Input } from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { ListDataEntity } from 'src/app/models/data-entities';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-list-data-entity-view',
    templateUrl: './list-data-entity-view.component.html',
    styleUrls: ['./list-data-entity-view.component.css'],
    standalone: false
})
export class ListDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context: WorkflowContextService) {
    super(layoutService, componentFactoryResolver, context);
  }
  listEntity: ListDataEntity;

  ngOnInit() {
    this.listEntity = <ListDataEntity>this.entity;
  }
}
